<template>
    <div>
        <date-picker v-if="pickerInfo.type == 'date'" v-model:value="value" :lang="lang" :type="pickerInfo.type" :format="format[pickerInfo.type]" placeholder="YYYY-mm-dd" confirm></date-picker>
        <date-picker v-if="pickerInfo.type == 'datetime'" v-model:value="value" :lang="lang" :type="pickerInfo.type" :format="'YYYY-MM-DD HH:mm'" :minute-step="minuteStep" placeholder="select datetime" confirm></date-picker>
        <date-picker v-if="pickerInfo.type == 'month'" v-model:value="value" :lang="lang" :type="'month'" :format="format['month']" placeholder="直近のお仕事の終了年月" confirm></date-picker>
        <!-- <date-picker v-model="value.value3" type="datetime" range :lang="lang" format="YYYY/MM/DD HH:mm" v-if="pickerInfo.ptype === '3'" :minute-step="minuteStep" confirm></date-picker> -->
        <input v-if="is_api === false" type="hidden" v-model="hiddenValue" :name="pickerInfo.name">
    </div>
</template>

<script>
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';

export default {
    props: {
        pickerInfo: {
            type: Object,
            required: true
        }
    },
    components: {
        DatePicker
    },
    created() {
        this.setPickerValue();
        // apiの場合はhidden要素なし
        this.is_api = this.pickerInfo.is_api ? this.pickerInfo.is_api : false;
    },
    mounted() {},
    data() {
        return {
            lang: {
                days: ['日', '月', '火', '水', '木', '金', '土'],
                months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                pickers: ['次の7日', '次の30日', '前の7日', '前の30日'],
            },
            minuteStep: 5,
            format: {
                'date': 'YYYY-MM-DD',
                'datetime': 'YYYY-MM-DD HH:mm:00',
                'time': 'HH:mm:00',
                'month': 'YYYY-MM'
            },
            value: this.pickerInfo.value,
            is_api: false // apiで使用するときは、余分なinput hiddenを削除
        }
    },
    computed: {
        hiddenValue: function () {
            // apiの場合はhidden要素なし
            if (this.is_api === false) {
                let date = null;
                if (this.value) {
                    const formatted_date = moment(this.value).format(this.format[this.pickerInfo.type]);
                    // 不正な値が入った場合は、invalid dateを返すため、除外
                    if (formatted_date != 'Invalid date') {
                        date = formatted_date;
                    }
                }

                return date;
            }
        },
    },
    methods: {
        /**
         * setPickerValue
         *
         * 当コンポーネント作成されるタイミングで呼ばれる
         *
         * model valueセットメソッド
         */
        setPickerValue() {
            if (!this.value) {
                this.value = null;
                return;
            }
            this.value = new Date(this.pickerInfo.value)
        },
        /** API用 メソッド*/
        sendForApi() {
            let date = null;
            const formatted_date = moment(this.value).format(this.format[this.pickerInfo.type]);
            // 不正な値が入った場合は、invalid dateを返すため、除外
            if (formatted_date != 'Invalid date') {
                date = formatted_date;
            }
            return date;
        }
    },
}
</script>
<style>
    .mx-datepicker {
        margin-right: 30px;
    }
    .mx-input-wrapper {
        display: block !important;
    }
    .mx-calendar-content .cell:hover {
        background-color: #f1d6d8 !important;
    }
    .mx-calendar-content .cell.active {
        background-color: #c44044 !important;
        color: #fff !important;
    }
    .mx-table-date .today {
        color: #c44044;
    }
    .mx-btn-text:hover{
        color: #d3898c !important;
    }
    .mx-datepicker-btn-confirm:hover {
        color: #c44044;
        border-color: #c44044;
    }
</style>
